import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';

import { SearchService } from 'app/services/search.service';
import { CompetitionService } from 'app/services/competition.service';
import { File } from 'app/models/file';
import { FileFilterList } from 'app/models/file-filter-list';
import { FileFilterOption } from 'app/models/file-filter-option';
import { DropdownMenuOption } from 'app/models/dropdown-menu-option';
import { AssetSortingType } from 'app/models/asset-sorting-type';

@Component({
  selector: 'app-search-dashboard',
  templateUrl: './search-dashboard.component.html',
  styleUrls: ['./search-dashboard.component.scss']
})
export class SearchDashboardComponent implements OnInit, OnChanges {
  @Input('manage') manage: boolean;
  @Input('searchText') searchText: string;
  // @Input('searchCompetition') searchCompetition: string;
  @Input('filters') filters = new FileFilterList(true, true, true, true, true, true);
  @Output('fileCount') fileCount = new EventEmitter();

  files: Array<any>;
  lastEvaluatedKey: any;
  showAll: boolean;
  sortingType: AssetSortingType;
  options: Array<DropdownMenuOption>;
  selected: DropdownMenuOption;

  constructor(
    private searchService: SearchService,
    private competitionService: CompetitionService
  ) {
    this.manage = false;
    this.showAll = !Object.keys(this.filters)
                          .some((key) => !(this.filters[key] as FileFilterOption).value);
  }

  ngOnInit() {
  }

  ngOnChanges() {
    setTimeout(() => this.getAll());
  }

  onSorting(sortingType) {
    this.sortingType = sortingType;
    this.getAll();
  }

  onShowAll() {
    this.showAll = !this.showAll;
    this.filters.setChecked(this.showAll);
    this.getAll();
  }

  onFilterChange(filter: string) {
    this.filters[filter].value = !this.filters[filter].value;
    this.showAll = !Object.keys(this.filters).some((key) => !this.filters[key].value);
    this.getAll();
  }

  onSelectCompetition(event): void {
    this.selected = event;
    this.getAll();
  }

  getNext() {
    this.getAll(this.lastEvaluatedKey);
  }

  getAll(lastEvaluatedKey?: string): void {
    const compId = //this.manage ? (this.selected ? this.selected.id : null) :
                                 this.competitionService.getCompetitionId();
    this.searchService
      .search(this.filters, this.searchText, compId, lastEvaluatedKey, this.sortingType)
      .subscribe(data => {
        this.files = this.files && lastEvaluatedKey ?
                         this.files.concat(data.Items) : data.Items;
        this.fileCount.emit(this.files.length);
        this.lastEvaluatedKey = data.LastEvaluatedKey;

        if (!this.options) {
          this.getCompetitions();
        }
      });
  }

  private getInfo() {
    const count = this.files ? this.files.length : 0;
    return '(' + count + (count > 1 ? ' RESULTS' : ' RESULT') + ')';
  }

  private getCompetitions(): void {
    const all = new DropdownMenuOption('ALL', 'ALL COMPETITIONS');
    this.options = this.competitionService.getDropdownMenuOptions();
    this.options.unshift(all);
    this.selected = all;
  }
}
